<template>
  <div>
    <b-modal
      id="modalNote"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      size="xl"
      :title="titleModal"
    >
      <template #default>
        <alert-error
          v-if="form.errors.get('message')"
          :form="form"
          :message="form.errors.get('message')"
        ></alert-error>
        <form @submit.prevent="submit" @keydown="form.onKeydown($event)">
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label for="note_titre"
                  >Titre <span class="text-danger">*</span></label
                >
                <input
                  class="form-control"
                  :class="{
                    'is-invalid': form.errors.has('titre'),
                  }"
                  id="note_titre"
                  v-model="form.titre"
                  type="text"
                  placeholder="Titre"
                  maxlength="50"
                  :required="mode !== 'show'"
                  :disabled="mode === 'show'"
                />
                <has-error :form="form" field="titre"></has-error>
              </div>
            </div>

            <div class="col-md-6">
              <div class="form-group">
                <label for="date"
                  >Date <span class="text-danger">*</span></label
                >
                <date-picker
                  v-model="form.date"
                  name="date"
                  placeholder="Date"
                  lang="fr"
                  format="DD/MM/YYYY"
                  value-type="DD/MM/YYYY"
                  :required="mode !== 'show'"
                  :disabled="mode === 'show'"
                ></date-picker>
                <input
                  class="form-control"
                  :class="{
                    'is-invalid': form.errors.has('date'),
                  }"
                  type="hidden"
                />
                <has-error :form="form" field="date"></has-error>
              </div>
            </div>

            <div class="col-md-12 mt-n4">
              <div class="form-group">
                <label for="note_description"
                  >Description (max : 500 caractères )
                  <span class="text-danger">*</span></label
                >
                <textarea
                  id="note_description"
                  v-model="form.description"
                  class="form-control"
                  :class="{
                    'is-invalid': form.errors.has('description'),
                  }"
                  rows="5"
                  maxlength="500"
                  :required="mode !== 'show'"
                  :disabled="mode === 'show'"
                ></textarea>
                <has-error :form="form" field="description"></has-error>
              </div>
            </div>
            <div class="px-3 mt-3" v-if="form.created_by">
              <span class="mr-2 text-custom-primary"
                ><i class="far fa-user text-custom-primary mr-1"></i> Auteur :
              </span>

              <span>{{
                form.created_by.prenom
                  ? form.created_by.prenom + ' ' + form.created_by.nom
                  : form.created_by.nom
              }}</span>
            </div>
          </div>
        </form>
      </template>
      <template #modal-footer>
        <button
          type="button"
          class="btn btn-danger mr-2"
          @click="$bvModal.hide('modalNote')"
        >
          Fermer
        </button>

        <button
          v-if="mode !== 'show'"
          type="submit"
          class="btn btn-custom-primary w-40"
          @click="submit"
          style="min-width: 100px"
        >
          {{ mode === 'create' ? 'Créer' : 'Enregistrer' }}
        </button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import URL from '@/http/rh/employe-objectif';
import Form from 'vform';
import DatePicker from 'vue2-datepicker';
export default {
  data() {
    return {
      form: new Form({
        date: this.$options.filters.formatDate(new Date(), 'DD/MM/YYYY'),
        titre: '',
        description: '',
      }),
      mode: '',
      titleModal: '',
    };
  },
  components: {
    DatePicker,
  },
  methods: {
    getNote(id, value) {
      window.axios
        .get(URL.NOTE + '/' + id, {
          params: {
            edit: value,
          },
        })
        .then((resp) => {
          Object.assign(this.form, resp.data.objectif_note);
        })
        .catch();
    },
    create() {
      this.titleModal = 'Ajout de nouvelle note';
      this.mode = 'create';
      this.form.reset();
      this.form.clear();
      this.$bvModal.show('modalNote');
    },
    async show(id) {
      this.mode = 'show';
      this.titleModal = "Aperçu d'une note";
      this.form.reset();
      this.form.clear();

      await this.getNote(id, false);
      await this.$bvModal.show('modalNote');
    },
    async edit(id) {
      this.mode = 'edit';
      this.titleModal = "Edition d'une note";
      this.form.reset();
      this.form.clear();

      await this.getNote(id, true);

      await this.$bvModal.show('modalNote');
    },
    submit() {
      this.form.objectif = this.currentObjectif.uuid;
      this.$bvModal.hide('modalNote');
      if (this.form.id) {
        //update
        this.form
          .put(URL.NOTE + '/' + this.form.id)
          .then((resp) => {
            this.showSimpleAlerte('top-end', 'success', resp.data.message);

            this.form.reset();
            this.form.clear();
            this.$emit('onRefresh');
          })
          .catch((err) => {
            this.form.errors.set('message', err.response.data.message);
            this.$bvModal.show('modalNote');
          });
      } else {
        //store
        this.form
          .post(URL.NOTE)
          .then((resp) => {
            this.showSimpleAlerte('top-end', 'success', resp.data.message);

            this.form.reset();
            this.form.clear();
            this.$emit('onRefresh');
          })
          .catch((err) => {
            this.form.errors.set('message', err.response.data.message);
            this.$bvModal.show('modalNote');
          });
      }
    },
  },
  props: ['currentObjectif'],
};
</script>

<style scoped lang="scss"></style>
